import { DialpadButton as ControlMenuV2DialapadButton } from "@/modules/calling/control-menu/v2/buttons/dialpad-button";

export const DialpadButton = () => (
  <ControlMenuV2DialapadButton className="w-16" />
);
